<template>
  <div>
    <div v-for="product in products.filter(p => filterActiveProduct(p))" :key="product.code"
         class="combo-item active">
        <div class="combo-item-col-left">
          <div class="combo-item-picture">
            <img :src="product.PICTURE">
          </div>
        </div>
        <div class="combo-item-col-right">
          <div class="combo-item-title">{{ productName(product) }}</div>
          <div class="combo-item-description">{{ product.INGREDIENTS }}</div>
          <div class="change-button" v-if="products.length > 1 || groupCode === 'pizza'"
               @click="changeComboItem(groupId)">{{ phrases.COMBO_ITEM_CHANGE }}</div>
        </div>
      </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ComboUtils from "@/components/combos/ComboUtils.vue";

export default {
  name: "ComboItem",
  props: ["products", "groupId", "groupCode"],
  computed: {
    ...mapGetters('combo', {
      combo: 'getCombo',
      comboItems: 'getComboItems',
    }),
  },
  methods: {
    changeComboItem: function (groupId){
      const component = this;
      component.$store.commit('combo/setComboItemGroupId', groupId);
      component.$store.commit('combo/setComboItemProducts', component.products);
      component.$store.commit('combo/setComboItemProductOffers', []);
    },
    productName: function (product){
      const component = this;
      const offers = component.getActiveOffer(product);
      if(offers.length){
        return offers[0].OFFER_NAME;
      }else{
        return product.NAME;
      }
    }
  },
  mixins: [ComboUtils]
}
</script>

<style scoped lang="scss">

  .active .combo-item.active{
    box-shadow: #e56621 0px 0px 2px 2px;
  }

  .combo-item {
    border: 1px solid #fff;
    border-radius: 0.25rem;
    margin: 0 0 0.25rem 0;
    cursor: pointer;
    padding: 0.25rem;
    font-size: 0.875rem;
    line-height: 0.875rem;
    display: flex;
    flex-direction: row;

    &-col-left{
      .combo-item-picture{
        img{
          width: 75px;
        }
      }
    }

    &-col-right{
      margin: 0 0 0 0.5rem;
    }

    &.active {
      background-color: #fff;
      font-family: "Panton SemiBold", sans-serif;
    }

    .change-button{
      margin: 0 0.25rem 0 0;
      cursor: pointer;
      padding: 0.25rem;
      border: 1px solid #000;
      border-radius: 0.25rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75rem;
    }
  }

  .combo-item-title{
    font-family: "Panton Bold", sans-serif;
    margin: 0;
    text-transform: uppercase;
  }

  .combo-item-description{
    font-size: 0.875rem;
    font-family: 'Panton', sans-serif;
    text-transform: lowercase;
    margin: 0.5rem 0;
  }
</style>